// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10ULi","controls":"styles_controls__14GTL","charLimit":"styles_charLimit__wDGqd","input":"styles_input__2a3c1","send":"styles_send__23eiN"};